// ─────────────────────────────────────────────────────────────────────────────
// DashboardHeader.js — page title + the "System Operational" pill.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./DashboardHeader.module.css";

export default function DashboardHeader() {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>Platform Dashboard</h1>
      <div className={styles.statusPill}>
        <span className={styles.statusDot} />
        System Operational
      </div>
    </div>
  );
}
